{
  "common": {
    "entityTypes": {
      "User": "Utilisateur",
      "Department": "Département",
      "Role": "Poste",
      "Process": "Processus",
      "ProcessStepRecording": "Enregistrement d'étape de processus",
      "ProcessStepAssignment": "Attribution d'étape de processus",
      "Survey": "Enquête",
      "Artifact": "Document",
      "ExternalContact": "Contact externe",
      "SoftwareSystem": "Système logiciel",
      "OrgFunction": "Fonction",
      "Organization": "Organisation",
      "BliksyGeneration": "Génération Bliksy",
      "ProcessConnection": "Connexion de processus",
      "ProcessChain": "Chaîne de processus",
      "ProcessMapPosition": "Position sur la carte des processus",
      "ProcessMapLaneDimension": "Dimension de voie de la carte des processus",
      "Tenant": "Locataire",
      "AppRegistry": "Registre d'applications",
      "PlatformSettings": "Paramètres de la plateforme"
    },
    "itemsSelected": "{{count}} sélectionnés",
    "selectAll": "Tout sélectionner",
    "showMore": "Afficher plus",
    "showLess": "Afficher moins",
    "deleted": "supprimé",
    "viewAll": "Tout voir",
    "noItemsFound": "Aucun élément trouvé",
    "Yes": "Oui",
    "No": "Non",
    "Back": "Retour",
    "back": "Retour",
    "Done": "Terminé",
    "Beta": "Bêta",
    "Save": "Enregistrer",
    "Remove": "Supprimer",
    "Edit": "Modifier",
    "Search": "Rechercher",
    "Create": "Créer",
    "Continue": "Continuer",
    "continue": "Continuer",
    "Submitting": "Envoi en cours...",
    "submit": "Soumettre",
    "Settings": "Paramètres",
    "Logout": "Se déconnecter",
    "loading": "Chargement...",
    "chatError": "Une erreur est survenue. Veuillez réessayer.",
    "retry": "Réessayer",
    "download": "Télécharger",
    "trialDaysLeft": "La période d'essai expire dans {{days}} jours",
    "trialLastDay": "La période d'essai expire aujourd'hui",
    "trialExpired": "La période d'essai a expiré",
    "ErrorBoundary": {
      "title": "Une erreur est survenue",
      "description": "Nous avons rencontré une erreur lors du chargement de cette page. Vous pouvez réessayer ou naviguer vers une autre page à l'aide de la barre latérale.",
      "tryAgain": "Réessayer",
      "goToSettings": "Aller aux paramètres",
      "goHome": "Aller à l'accueil",
      "viewErrorDetails": "Voir les détails de l'erreur"
    },
    "NotFound": {
      "title": "Fonctionnalité à venir",
      "description": "Nous travaillons activement sur cette fonctionnalité. Elle sera bientôt disponible !",
      "suggestion": "En attendant, explorez d'autres fonctionnalités ou consultez notre feuille de route pour voir ce qui arrive.",
      "goToDashboard": "Aller au tableau de bord",
      "goToLogin": "Aller à la connexion",
      "viewRoadmap": "Voir la feuille de route"
    },
    "Apps": {
      "notFound": "Application introuvable ou non disponible pour cette organisation.",
      "manageTitle": "Catalogue d'applications",
      "manageDescription": "Activez les applications de votre organisation et attribuez des sièges",
      "enabled": "Activée",
      "disabled": "Désactivée",
      "activation": "Activation",
      "enableSuccess": "Application activée avec succès.",
      "enableFailed": "Échec de l'activation de l'application.",
      "disableSuccess": "Application désactivée avec succès.",
      "disableFailed": "Échec de la désactivation de l'application.",
      "seatsTitle": "Sièges d'application",
      "seatsMembers": "Personnes ayant accès",
      "seatsSaved": "Sièges enregistrés.",
      "seatDataIntro": "Un siège accorde un accès en lecture complet, dans cette application, aux données suivantes : {{categories}}.",
      "seatDataCategories": {
        "processes": "Processus",
        "processSteps": "Détails des étapes de processus, y compris les notes et les données de capacité et de coût",
        "surveys": "Réponses aux enquêtes, y compris les évaluations et commentaires individuels par étape, la fréquence des cas et la durée de traitement – pour tous les processus, quel que soit le département",
        "systems": "Systèmes",
        "roles": "Fonctions",
        "teams": "Équipes",
        "departments": "Départements",
        "orgMembers": "Répertoire des membres (y compris l'adresse e-mail et le statut)",
        "artifacts": "Documents",
        "externalContacts": "Contacts externes (y compris l'adresse e-mail)",
        "processChains": "Chaînes de processus (y compris les processus liés)"
      },
      "notAllowed": "Non autorisée",
      "notAllowedNotice": "Cette application n'est pas autorisée pour votre organisation.",
      "seatsCount": "{{used}} / {{limit}} sièges",
      "seatsNeedEnabledApp": "Les sièges ne peuvent être attribués qu'une fois l'application activée.",
      "seatsOverLimit": "{{over}} au-dessus de la limite",
      "seatsNoCapacity": "Aucun siège disponible",
      "category": {
        "analysis": "Analyse",
        "dataCapture": "Saisie de données",
        "sales": "Ventes"
      }
    },
    "Sidebar": {
      "Dashboard": "Tableau de bord",
      "ActiveMonitoring": "Surveillance active",
      "ComingSoon": "Bientôt disponible",
      "ensureContinuity": "La surveillance active assure la continuité de votre activité.",
      "AreTheRelevant": "Toutes les personnes pertinentes du processus sont-elles disponibles en ce moment ?",
      "areThereBottleneck": "Y a-t-il des goulots d'étranglement dans votre paysage de processus ?",
      "LearnMore": "En savoir plus",
      "Processes": "Processus",
      "AllProcesses": "Tous les processus",
      "MyTasks": "Mes tâches",
      "ProcessLandscape": "Carte des processus",
      "ProcessChains": "Chaînes de processus",
      "ProcessEditor": "Éditeur de processus",
      "Organization": "Organisation",
      "MyDepartment": "Mon département",
      "MyOrgFunctions": "Mes fonctions",
      "MySystems": "Mes systèmes",
      "Systems": "Systèmes",
      "OrgCatalogs": "Catalogues de l'organisation",
      "AllDepartments": "Tous les départements",
      "AllFunctions": "Toutes les fonctions",
      "AllTeams": "Toutes les équipes",
      "AllMembers": "Toutes les personnes",
      "AllSoftwareSystems": "Tous les systèmes logiciels",
      "SystemLandscape": "Paysage système",
      "AllExternalContacts": "Tous les contacts externes",
      "AllArtifacts": "Tous les documents",
      "OrgChart": "Organigramme",
      "Analytics": "Analytique",
      "AiUsage": "Utilisation de l'IA",
      "SeeWhichPeople": "Découvrez quelles personnes ou systèmes sont critiques dans vos processus, où se trouve le plus grand potentiel d'amélioration ?",
      "Survey": "Enquête",
      "Apps": "Applications",
      "ManageApps": "Gérer les applications",
      "DataSync": "Synchronisation des données",
      "needSpecificDetail": "Avez-vous besoin de détails spécifiques sur certains processus ? Qui est l'expert ? Besoin de répondre à des questions sur la durabilité ?",
      "Settings": "Paramètres",
      "OrgSettings": "Paramètres de l'organisation",
      "UserManagement": "Gestion des utilisateurs",
      "TenantManagement": "Gestion des locataires",
      "InitialConfig": "Configuration initiale",
      "SoftwareSystems": "Systèmes logiciels",
      "MyOverview": "Mon environnement de travail",
      "RecordingDashboard": "Cockpit d'enregistrement",
      "AuditLogs": "Journal d'audit",
      "ShadowSystems": "Systèmes fantômes",
      "Help": "Aide",
      "PartnerContent": "Contenus partenaires",
      "AccountManagement": "Comptes"
    },
    "Name": "Nom",
    "Email": "E-mail",
    "Logo": "Logo",
    "Change": "Modifier",
    "Upload": "Télécharger",
    "Created": "Créé",
    "Description": "Description",
    "Details": "Détails",
    "Category": "Catégorie",
    "Type": "Type",
    "Status": "Statut",
    "FirstName": "Prénom",
    "LastName": "Nom",
    "Actions": "Actions",
    "edit": "Modifier",
    "actions": "Actions",
    "viewDetail": "Voir le détail",
    "clone": "Dupliquer",
    "Updated": "Mis à jour",
    "UserTypes": "Types d'utilisateur",
    "Classification": "Classification",
    "DepartmentManager": "Responsable de département",
    "Error": "Erreur",
    "errorOccurred": "Une erreur est survenue",
    "success": "Succès",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "close": "Fermer",
    "confirm": "Confirmer",
    "processing": "Traitement en cours...",
    "sending": "Envoi en cours...",
    "delete": "Supprimer",
    "create": "Créer",
    "confirmDelete": "Confirmer la suppression",
    "confirmDeleteDescription": "Êtes-vous sûr de vouloir supprimer {{entity}} ? Cette action est irréversible.",
    "unsavedChanges": "Modifications non enregistrées",
    "unsavedChangesDescription": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer ?",
    "stay": "Continuer la modification",
    "discardChanges": "Annuler les modifications",
    "noOptionsAvailable": "Aucune option disponible",
    "Instructions": "Instructions",
    "add": "Ajouter",
    "search": "Rechercher",
    "searchOrCreate": "Rechercher ou créer...",
    "noResults": "Aucun résultat trouvé.",
    "uploading": "Téléchargement",
    "uploadingEllipsis": "Téléchargement...",
    "or": "Ou",
    "you": "Vous",
    "moreCount": "(+{{count}} de plus)",
    "dropzone": {
      "dragAndDrop": "Glissez-déposez, ou",
      "clickToSelect": "cliquez pour sélectionner des fichiers",
      "maxFileSize": "Fichiers de {{maxSize}} Mo maximum autorisés",
      "rejectedType": "Non ajouté – type de fichier non pris en charge : {{names}}",
      "rejectedSize": "Non ajouté – plus de {{maxSize}} Mo : {{names}}"
    },
    "notAvailable": "N/D",
    "system": "Système",
    "empty": "(vide)",
    "error": "Erreur",
    "excelUpload": {
      "downloadTemplateTitle": "Télécharger le modèle",
      "downloadTemplateDesc": "Contient exactement ces colonnes – remplissez et importez.",
      "parsedRows": "{{count}} lignes lues",
      "parseFailed": "Le fichier n'a pas pu être lu",
      "headerMismatch": "Aucune colonne ne correspond au modèle. Veuillez utiliser les en-têtes de colonnes du modèle.",
      "dragOrBrowse": {
        "prefix": "Glissez-déposez, ou",
        "browse": "cliquez pour sélectionner des fichiers"
      },
      "maxFileSize": "Fichiers de 10 Mo maximum autorisés"
    },
    "Workspaces": "Espaces de travail",
    "Help": "Aide"
  },
  "userTypes": {
    "system_admin": "Administrateur système",
    "system_admin_description": "Accès complet au système et configuration",
    "org_manager": "Responsable d'organisation",
    "org_manager_description": "Gérer les paramètres et les personnes de l'organisation",
    "org_member": "Membre de l'organisation",
    "org_member_description": "Membre standard avec accès de base",
    "partner_admin": "Admin partenaire",
    "partner_admin_description": "Gère les leads, l'équipe et le profil de l'organisation partenaire",
    "partner_staff": "Collaborateur partenaire",
    "partner_staff_description": "Enregistre et suit ses propres leads dans l'espace partenaire"
  },
  "userStatus": {
    "inactive": "Inactif",
    "pending": "En attente",
    "active": "Actif",
    "suspended": "Suspendu"
  },
  "userClassification": {
    "internal": "Employé interne",
    "external": "Employé externe",
    "internalShort": "Interne",
    "externalShort": "Externe"
  },
  "seatLimits": {
    "title": "Limites de sièges",
    "systemAdmins": "Administrateurs système",
    "orgManagers": "Responsables d'organisation",
    "members": "Utilisateurs de base"
  },
  "bpmnEventTypes": {
    "none": "Démarrage manuel",
    "none_description": "Démarré manuellement par une personne",
    "message": "Demande entrante",
    "message_description": "Déclenché par une demande entrante (p. ex. e-mail, appel ou message)",
    "timer": "Échéance / Délai",
    "timer_description": "Déclenché à un moment précis ou à l'expiration d'un délai",
    "conditional": "Conditionnel",
    "conditional_description": "Déclenché lorsqu'une condition devient vraie",
    "signal": "Signal",
    "signal_description": "Déclenché par une diffusion de signal",
    "multiple": "Multiple",
    "multiple_description": "Plusieurs déclencheurs, un seul est requis",
    "parallelMultiple": "Multiple parallèle",
    "parallelMultiple_description": "Plusieurs déclencheurs, tous sont requis",
    "error": "Erreur",
    "error_description": "Déclenché par une erreur",
    "cancel": "Annulation",
    "cancel_description": "Déclenché lors de l'annulation d'une transaction",
    "escalation": "Escalade",
    "escalation_description": "Déclenché par une escalade",
    "compensation": "Compensation",
    "compensation_description": "Déclenché pour la gestion de compensation",
    "link": "Lien",
    "link_description": "Lien vers une autre partie du processus",
    "terminate": "Terminer",
    "terminate_description": "Met fin immédiatement au processus"
  },
  "pageTitles": {
    "home": "Accueil",
    "login": "Connexion",
    "myTasks": "Mes tâches",
    "myTasksWithCount": "Mes tâches ({{count}})",
    "processDetail": "{{name}}",
    "processFlowFullscreen": "{{name}} - Visualisation du flux",
    "allProcesses": "Tous les processus",
    "createProcesses": "Créer des processus",
    "startRecording": "Démarrer l'enregistrement - {{name}}",
    "stepRecording": "Enregistrement - {{name}}",
    "orgMembers": "Personnes",
    "orgMemberDetail": "{{name}}",
    "departments": "Départements",
    "departmentDetail": "{{name}}",
    "mySystems": "Mes systèmes",
    "orgFunctionDetail": "{{name}}",
    "functions": "Fonctions",
    "teams": "Équipes",
    "myOrgFunctions": "Mes fonctions",
    "systems": "Systèmes",
    "systemDetail": "{{name}}",
    "systemLandscape": "Paysage système",
    "processMap": "Carte des processus",
    "processChains": "Chaînes de processus",
    "processEditor": "Éditeur de processus",
    "artifacts": "Documents",
    "artifactDetail": "{{name}}",
    "externalContacts": "Contacts externes",
    "externalContactDetail": "{{name}}",
    "orgChart": "Organigramme",
    "settings": "Paramètres",
    "tenants": "Locataires",
    "departmentMembers": "Personnes dans mon département",
    "departmentTeams": "Équipes de mon département",
    "userManagement": "Gestion des utilisateurs",
    "softwareList": "Liste des logiciels",
    "manageApps": "Gérer les applications",
    "dataSync": "Synchronisation des données",
    "createDepartments": "Créer des départements",
    "dashboard": "Mon environnement de travail",
    "shadowSystems": "Systèmes fantômes",
    "help": "Service client",
    "supportTickets": "Tickets de support"
  },
  "noDashboardAccess": {
    "title": "Pas encore d'accès à un espace de travail",
    "description": "Votre compte n'a pas accès à une vue d'espace de travail. Veuillez contacter votre administration afin qu'un rôle approprié vous soit attribué."
  },
  "about": {
    "title": "À propos de BLIKS IO",
    "frontendVersion": "Frontend",
    "backendVersion": "Backend",
    "buildInfo": "Build"
  },
  "helpCenter": {
    "title": "Service client",
    "subtitle": "Soumettez une demande et suivez vos tickets",
    "contactUs": "Contact & Support",
    "contactSubtitle": "Contactez notre équipe de support",
    "viewTickets": "Mes tickets",
    "openTicketsCount": "Tickets ouverts : {{count}}",
    "ticketsWithNewReplyCount": "Tickets avec une nouvelle réponse : {{count}}",
    "contact": {
      "category": "Catégorie",
      "categoryPlaceholder": "Comment pouvons-nous vous aider ?",
      "categories": {
        "incident": "Signaler un problème",
        "request": "Soumettre une demande",
        "change": "Demander un changement",
        "complaint": "Déposer une réclamation"
      },
      "summary": "Objet",
      "summaryPlaceholder": "Bref résumé de votre demande",
      "description": "Description",
      "descriptionPlaceholder": "Veuillez décrire votre demande en détail...",
      "submit": "Envoyer la demande",
      "successTitle": "Demande envoyée !",
      "successMessage": "Votre demande a été envoyée. Notre équipe vous recontactera prochainement.",
      "errorMessage": "Une erreur est survenue. Veuillez réessayer ou contacter {{supportEmail}}.",
      "newRequest": "Soumettre une autre demande",
      "ticketReference": "Numéro de ticket : {{number}}",
      "attachmentsTitle": "Joindre des captures d’écran",
      "attachmentsHint": "Jusqu’à {{count}} images, {{size}} Mo max. chacune (PNG, JPEG, WebP)",
      "attachmentRemove": "Supprimer {{name}}"
    }
  },
  "supportTickets": {
    "newReply": "Nouvelle réponse",
    "title": "Tickets de support",
    "subtitle": "Consultez vos demandes de support",
    "loadErrorTitle": "Impossible de charger vos tickets",
    "loadError": "Le support est temporairement indisponible. Veuillez réessayer plus tard.",
    "empty": "Aucun ticket",
    "emptyDescription": "Vous n'avez pas encore créé de ticket de support.",
    "open": "Ouvert",
    "closed": "Fermé",
    "status": {
      "received": "Reçue",
      "inProgress": "En cours",
      "resolved": "Résolue",
      "merged": "Fusionnée"
    },
    "detail": {
      "title": "Demande d’assistance",
      "loadErrorTitle": "Impossible de charger cette demande",
      "loadError": "Le support est temporairement indisponible. Veuillez réessayer plus tard.",
      "noMessages": "Cette demande ne contient encore aucun message.",
      "notLiveChat": "Pas de chat en direct – les réponses arrivent ici et par e-mail, en général rapidement.",
      "authorYou": "Vous",
      "authorSupport": "Support",
      "replyLabel": "Répondre",
      "replyPlaceholder": "Écrivez une réponse au support...",
      "replySubmit": "Envoyer la réponse",
      "sendShortcut": "⌘/Ctrl + Entrée",
      "attach": "Joindre une image",
      "replyError": "Votre réponse n’a pas pu être envoyée. Veuillez réessayer.",
      "resolvedHint": "Cette demande est clôturée. Si un point reste en suspens, vous pouvez la rouvrir.",
      "mergedNotice": "Cette demande a été fusionnée avec une autre demande et y est traitée.",
      "mergedLink": "Voir la demande n° {{number}}",
      "reopenAction": "Rouvrir la demande",
      "reopenLabel": "Qu’est-ce qui reste en suspens ?",
      "reopenSubmit": "Envoyer et rouvrir",
      "attachmentDownload": "Télécharger {{name}}",
      "attachmentDownloadAction": "Télécharger",
      "attachmentOpen": "Ouvrir {{name}}",
      "attachmentError": "La pièce jointe n’a pas pu être téléchargée. Veuillez réessayer."
    }
  }
}
